<nb-card>
  <nb-card-header>
    <div class="d-flex justify-content-between">
      Logs
      <button
        (click)="dismiss()"
        type="button"
        class="btn-close"
        aria-label="Close"
      ></button></div
  ></nb-card-header>
  <nb-card-body style="padding-bottom: 0">
    <div
      class="mb-2 mt-2 d-flex flex-row-reverse justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center justify-content-end">
        <ng-select
          #callIdSelect
          [items]="callIdList"
          bindLabel="callId"
          bindValue="callId"
          [(ngModel)]="currentCallId"
          (change)="getLog()"
          placeholder="Select ID"
          class="custom-input"
          status="primary"
          (clear)="clearLog()"
          [editableSearchTerm]="true"
          [nbSpinner]="loading"
          nbSpinnerSize="small"
          nbSpinnerStatus="primary"
          style="width: 290px !important"
          [virtualScroll]="true"
          (scroll)="onScroll($event)"
          (scrollToEnd)="onScrollToEnd()"
          (search)="onSearch($event)"
          (open)="onDropdownOpen()"
        >
          >
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <div class="function-item">
              <span>{{ item.callId }}</span>
            </div>
          </ng-template>
        </ng-select>

        <!-- <button
            nbButton
            status="basic"
            class="me-2 button-basic"
            (click)="export()"
            size="small"
            [nbSpinner]="isLoading"
            nbSpinnerSize="small"
            nbSpinnerStatus="primary"
            [disabled]="disabled || isLoading"
          >
            <nb-icon icon="log-out-outline"></nb-icon>Export
          </button> -->

        <button
          title="Clear all log"
          status="primary"
          type="button"
          nbButton
          size="small"
          (click)="clear()"
          [disabled]="isReadOnly == true"
          class="me-2"
        >
          Clear
        </button>
        <button
          [title]="cdrDisabled ? 'Open CR' : 'Open CDR'"
          status="primary"
          type="button"
          nbButton
          size="small"
          [disabled]="isReadOnly == true || currentCallId == 'All Log'"
          (click)="openCDR()"
          class="me-2"
        >
          {{ cdrDisabled ? "CR" : "CDR" }}
        </button>
        <button
          title="Reload"
          status="primary"
          type="button"
          nbButton
          size="small"
          (click)="reloadCallID()"
        >
          Reload
        </button>
      </div>
      <div
        *ngIf="from && this.currentCallId !== 'All Log'"
        class="log-info-container d-flex flex-wrap align-items-center gap-3 ms-2"
      >
        <!-- Log Type -->
        <div class="d-flex align-items-center">
          <div class="log-label" [title]="logType">
            <span class="text-uppercase">{{ logType }}</span>
          </div>
        </div>

        <!-- Divider -->
        <div class="log-divider"></div>

        <!-- From -->
        <div class="d-flex align-items-center gap-2">
          <label class="log-label">From:</label>
          <span class="log-value" [title]="from">{{ from }}</span>
        </div>

        <!-- Divider -->
        <div class="log-divider"></div>

        <!-- To -->
        <div class="d-flex align-items-center gap-2">
          <label class="log-label">To:</label>
          <span class="log-value" [title]="to">{{ to }}</span>
        </div>

        <!-- Divider -->
        <div class="log-divider"></div>

        <!-- ID -->
        <div class="d-flex align-items-center gap-2">
          <label class="log-label">ID:</label>
          <span class="log-value">{{ currentCallId }}</span>
        </div>
      </div>
    </div>
    <log-list
      [data]="logList"
      (disabled)="setDisabledExport($event)"
      (updateLoading)="updateLoading($event)"
      (dataLogExport)="dataLogExport($event)"
      (updateLogInformation)="updateLogInformation($event)"
      class="flex-grow-1 w-100"
    >
    </log-list>
  </nb-card-body>
</nb-card>
